<template>
  <!-- 意见反馈 -->
  <div class="feedBack">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 用户账号 -->
        <el-form-item :label="$t('pages.user.text5')">
          <el-input
            v-model="searchParams.appAccount"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <!-- 反馈时间 -->
        <el-form-item :label="$t('pages.user.text11')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- 按钮区域 -->
      <div class="button">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['feedback:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['feedback:reset']"
        ></DiluButton>
        <DiluButton
          type="export"
          @click="doExport"
          v-permission="['feedback:export']"
        ></DiluButton>
      </div>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      :total="total"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 用户账号 -->
      <el-table-column
        prop="appAccount"
        :label="$t('pages.user.text5')"
        width="180"
        align="center"
      >
      </el-table-column>
      <!-- 反馈内容 -->
      <el-table-column
        prop="feedbackContent"
        :label="$t('pages.user.text12')"
        align="center"
      >
      </el-table-column>
      <!-- 反馈时间 -->
      <el-table-column
        prop="createdAt"
        :label="$t('pages.user.text11')"
        align="center"
      >
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="feedbackTextSee(scope.row)"
              type="text"
              v-permission="['feedback:see']"
              >{{ $t("button.look") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 查看弹窗 -->
    <FeedBackSee
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      :currentOpinion="currentOpinion"
    />
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import FeedBackSee from "./moudle/feedbackSee";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      //选中的开始日期之前的日期禁选
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      dialogVisible: false, //查看意见反馈弹窗
      tableConfig: {
        isTree: false,
        isPage: true, //打开分页功能
      },
      searchParams: {
        id: "",
        appAccount: "", //用户账号
        createdAt: "", //反馈时间
        feedbackContent: "", //反馈内容
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //反馈开始时间
        stopAt: "", //反馈结束时间
      },
      total: 0,
      tableData: [],
      currentOpinion: {},
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    FeedBackSee,
  },
  mounted() {
    this.feedbackList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.feedbackList();
    },
    //更改开始日期时间时结束日期时间置空重选
    startChange() {
      this.searchParams.stopAt = null;
    },
    // 获取意见反馈列表（分页）
    feedbackList() {
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3")); //请选择结束日期
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2")); //请选择开始日期
        }
      }
      this.request.feedbackList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    // 关闭查看弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    // 重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        id: "",
        appAccount: "", //用户账号
        createdAt: "", //反馈时间
        feedbackContent: "", //反馈内容
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //反馈开始时间
        stopAt: "", //反馈结束时间
      };
      this.total = 0;
      this.feedbackList();
    },
    // 查看
    feedbackTextSee(e) {
      let obj = JSON.parse(JSON.stringify(e));
      obj.feedbackImages = JSON.parse(e.feedbackImages);
      this.dialogVisible = true;
      this.currentOpinion = obj;
    },
    // 导出
    doExport() {
      this.request.feedbackExport(this.searchParams).then();
    },
    // 翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          id: "",
          appAccount: "", //用户账号
          createdAt: "", //反馈时间
          feedbackContent: "", //反馈内容
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          startAt: "", //反馈开始时间
          stopAt: "", //反馈结束时间
        };
      }
      this.searchParams.pageNum = e;
      this.feedbackList();
    },
  },
};
</script>

<style scoped>
.feedBack {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
  flex-wrap: wrap;
}
.button {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>